import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { SectionHeading } from './SectionHeading';
import { tomos, tomoIncludes } from '../data/content';
export function TomosSection() {
  return <section aria-labelledby="tomos" className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-10" data-id="element-279" data-mp="1p4v7cp8lzity">
      <Reveal data-id="element-280" data-mp="1u1ve72da8pm4">
        <SectionHeading id="tomos" eyebrow="Un sistema progresivo para aprender, hacer y emprender" title="6 Tomos completos" data-id="element-281" data-mp="1u4rg11s93yfu" />
      </Reveal>

      <ol className="mt-5 grid gap-3 md:grid-cols-2 lg:grid-cols-3" data-id="element-282" data-mp="11e9cy0rj1x2f">
        {tomos.map((tomo, i) => <Reveal key={tomo.title} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-xl border border-line bg-surface p-5" data-id="element-283" data-mp="16brev774nc0x" data-mpi={i}>
            <span className="font-display text-xs font-bold uppercase tracking-[0.14em] text-accent" data-id="element-284" data-mp="2hrzf31z36b9f">
              Tomo {i + 1}
            </span>
            <h3 className="mt-1.5 font-display text-lg font-extrabold uppercase leading-tight text-ink" data-id="element-285" data-mp="2qoqor4pfdf26">
              {tomo.title}
            </h3>
            <p className="mt-2 text-sm font-semibold text-volt" data-id="element-286" data-mp="2mneu2krp23n4">{tomo.lead}</p>
            <p className="mt-1.5 text-sm leading-relaxed text-ink-muted" data-id="element-287" data-mp="2hm90kkq7mccj">
              {tomo.desc}
            </p>
          </Reveal>)}
      </ol>

      <Reveal className="mt-4 rounded-xl border border-line bg-surface-alt p-5 md:p-6" data-id="element-288" data-mp="27p4esm0a0iw9">
        <h3 className="text-center font-display text-base font-extrabold uppercase text-ink" data-id="element-289" data-mp="22yo06ykpyr8b">
          Cada tomo incluye
        </h3>
        <ul className="mt-3 grid gap-x-6 gap-y-2 sm:grid-cols-2 lg:grid-cols-3" data-id="element-290" data-mp="1yw9f07tkvfdv">
          {tomoIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-ink-muted" data-id="element-291" data-mp="1tzj4e00jlbzu">
              <CheckIcon size={14} className="mt-1 flex-shrink-0 text-success" strokeWidth={3} data-id="element-292" data-mp="1p0poy21p3ax1" />
              <span data-id="element-293" data-mp="1abeju6444sb2">{item}</span>
            </li>)}
        </ul>
      </Reveal>
    </section>;
}